import { ExpandableList } from '@optimus-web/core';
import { CommonMenuItems } from './MenuItems';
import { SettingsMenu } from './SettingsMenu';

export const ApplicationProviderMenu = () => (
    <ExpandableList>
        <SettingsMenu value="settings" />
        <CommonMenuItems />
    </ExpandableList>
);
